import LabeledSelect from "./LabeledSelect";
import {debounce, isEmpty} from "lodash";
import {useCallback, useEffect, useState} from "react";
import {requestBrandSearch} from "../../redux/sagas/requests/searchService";
import {getCategory} from "../../redux/sagas/requests/categoryService";
import {getBrand} from "../../redux/sagas/requests/brandService";

const BrandSearchSelect = ({
                             label, value, onChange, placeholder = "Search Brands",
                             emptyMsg = "No data", extData, ...props
                           }) => {

  //todo search a better way to load default values
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    if (extData && !value && !isFetching && onChange) {

      setIsFetching(true);
      getBrand(extData).then((resp) => {
        setIsFetching(false);
        onChange(resp.data);
      }).catch((err) => {
        setIsFetching(false);
      });

    }

  }, [extData]);




  // noinspection JSCheckFunctionSignatures
  const debouncedSearchBrand = useCallback(
    debounce((inputText, callback) => {
      handleSearchBrand(inputText).then((options) => callback(options));
    }, 500),
    []
  );


  return (
    <LabeledSelect label={label} value={value} getOptionLabel={(option) => option.name} loading={isFetching}
                   isDisabled={isFetching}
                   getOptionValue={(option) => option.id} placeholder={placeholder}
                   onChange={onChange} emptyMsg={emptyMsg} {...props} loadOptions={debouncedSearchBrand}/>
  );


};

export default BrandSearchSelect;

const handleSearchBrand = (input) => {
  if (isEmpty(input)) {
    return [];
  }

  return requestBrandSearch(input).then((response) =>
    response.data ? response.data : []
  );

};
